import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class ExpenseService {
  private apiUrl = '/expenses';
  private apiSpringUrl = '/spring/expenses';

  constructor(private http: HttpService) { }

  get(ownerId?: number): Promise<any> {
    let url = environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl;
    if (ownerId) url += '?ownerId=' + ownerId
    return this.http.get(url);
  }

  未使用
  post(
    ownerId: number,
    bookDt: Date,
    salesgroupId: number,
    unitpricedispNr: number,
    pcsNr: number,
    pricedispNr: number,
    typetaxCd: string,
    expensetaxNr: number,
    expensememoTx: string,
    updprogramCd: string
  ): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl;
    const bookDate = new Date(bookDt);
    const jsonInput = {
      ownerId: ownerId,
      bookDt: bookDate.getFullYear() + '/' + ('0' + (bookDate.getMonth() + 1)).slice(-2) + '/' + ('0' + bookDate.getDate()).slice(-2),
      bookyearmonthTx: bookDate.getFullYear() + ('0' + (bookDate.getMonth() + 1)).slice(-2),
      salesgroupId: salesgroupId,
      unitpricedispNr: unitpricedispNr,
      pcsNr: pcsNr,
      pricedispNr: pricedispNr,
      typetaxCd: typetaxCd,
      expensetaxNr: expensetaxNr,
      expensememoTx: expensememoTx,
      updprogramCd: updprogramCd
    };
  
    return this.http.post(url, jsonInput);
  }

  put(
    salesexpenseId: number,
    bookDt: Date,
    salesgroupId: number,
    unitpricedispNr: number,
    pcsNr: number,
    pricedispNr: number,
    typetaxCd: string,
    cancelFl: number,
    notinvoiceFl: number,
    expensetaxNr: number,
    expensememoTx: string,
    updprogramCd: string
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/${salesexpenseId}`;
    const bookDate = new Date(bookDt);
    const jsonInput = {
      bookDt: bookDate.getFullYear() + '/' + ('0' + (bookDate.getMonth() + 1)).slice(-2) + '/' + ('0' + bookDate.getDate()).slice(-2),
      bookyearmonthTx: bookDate.getFullYear() + ('0' + (bookDate.getMonth() + 1)).slice(-2),
      salesgroupId: salesgroupId,
      unitpricedispNr: unitpricedispNr,
      pcsNr: pcsNr,
      pricedispNr: pricedispNr,
      typetaxCd: typetaxCd,
      cancelFl: cancelFl,
      notinvoiceFl: notinvoiceFl,
      expensetaxNr: expensetaxNr,
      expensememoTx: expensememoTx,
      updprogramCd: updprogramCd
    };

    return this.http.put(url, jsonInput);
  }

  postAll(data: any): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/all`;
    return this.http.post(url, data);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/expense/expense.service.ts